(() => {
  const BUTTON_SELECTOR =
    '[data-button-003]';

  const MASK_SELECTOR =
    '[data-button-003-mask]';

  const SVG_GROUP_SELECTOR =
    '[data-button-003-svg-group]';

  const READY_ATTRIBUTE =
    'data-wambolt-action-ready';


  let buttonId = 0;


  /* =========================================
     GET BUTTONS
     ========================================= */

  function getButtons(
    scope = document
  ) {
    if (!scope) {
      return [];
    }


    const buttons = [];


    if (
      scope instanceof Element &&
      scope.matches(
        BUTTON_SELECTOR
      )
    ) {
      buttons.push(
        scope
      );
    }


    if (
      typeof scope.querySelectorAll ===
      'function'
    ) {
      buttons.push(
        ...scope.querySelectorAll(
          BUTTON_SELECTOR
        )
      );
    }


    return Array.from(
      new Set(
        buttons
      )
    );
  }


  /* =========================================
     INITIALIZE BUTTON
     ========================================= */

  function initButton(
    button
  ) {
    if (
      !button ||
      !(button instanceof Element)
    ) {
      return;
    }


    if (
      button.hasAttribute(
        READY_ATTRIBUTE
      )
    ) {
      return;
    }


    const mask =
      button.querySelector(
        MASK_SELECTOR
      );


    const svgGroup =
      button.querySelector(
        SVG_GROUP_SELECTOR
      );


    /*
     * Text-only controls intentionally contain
     * no icon mask and require no JS setup.
     */
    if (
      !mask &&
      !svgGroup
    ) {
      button.setAttribute(
        READY_ATTRIBUTE,
        'true'
      );

      return;
    }


    /*
     * Incomplete SVG markup should never receive
     * an invalid mask reference.
     */
    if (
      !mask ||
      !svgGroup
    ) {
      return;
    }


    buttonId += 1;


    const maskId =
      `wambolt-action-mask-${buttonId}`;


    mask.id =
      maskId;


    svgGroup.setAttribute(
      'mask',
      `url(#${maskId})`
    );


    button.setAttribute(
      READY_ATTRIBUTE,
      'true'
    );
  }


  /* =========================================
     INITIALIZE SCOPE
     ========================================= */

  function initScope(
    scope = document
  ) {
    getButtons(
      scope
    ).forEach(
      initButton
    );
  }


  /* =========================================
     INITIAL DOCUMENT
     ========================================= */

  function start() {
    initScope(
      document
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true,
      }
    );
  } else {
    start();
  }


  /* =========================================
     BARBA
     ========================================= */

  window.addEventListener(
    'wambolt:page:enter',
    (event) => {
      const container =
        event.detail?.container ||
        document;


      initScope(
        container
      );
    }
  );


  /* =========================================
     SHOPIFY THEME EDITOR
     ========================================= */

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initScope(
        event.target
      );
    }
  );
})();